import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
dayjs.extend(duration)

/**
 * Función que formatea un tiempo dado en segundos en el formato HH[h]:mm[m]:ss[s].
 *
 * @example
 * const tiempo = 3901;
 * const tiempoFormateado = formatearTiempo(tiempo); // 01h:5m:01s
 * @param {number} tiempoEnSegundos - Tiempo en segundos a formatear.
 * @returns {string} Tiempo formateado (HH[h]:mm[m]:ss[s]).
 */
export const formatearTiempo = (tiempoEnSegundos) => {
  const duration = dayjs.duration(+tiempoEnSegundos, 'seconds')
  const tiempoFormateado = duration.format('HH[h]:mm[m]:ss[s]')
  return tiempoFormateado
}
